export default __webpack_public_path__ + "static/media/radio-checked.c3ce3aa4.svg";